import { getClassFromSubject, getSubjectId, getTeacherSubjects } from "./teacherSubjects";

export const HOMEROOM_MIN_SUBJECTS = 1;

export const HOMEROOM_ASSIGN_SUBJECTS_MSG =
    "Choose at least one subject in this class for the form teacher.";

/** Subject ids this teacher already teaches in the given class. */
export function getTeacherSubjectIdsInClass(teacher, classId) {
    if (!teacher || !classId) return [];
    const cid = String(classId);
    return getTeacherSubjects(teacher)
        .filter((sub) => {
            const cls = getClassFromSubject(sub);
            return cls && String(cls._id) === cid;
        })
        .map((sub) => String(getSubjectId(sub)))
        .filter(Boolean);
}

/**
 * Assign / unassign subjects in one class, then caller sets classTeacherId.
 */
export async function syncTeacherSubjectsForClass(
    dispatch,
    { teacherId, classId, selectedSubjectIds, teacher, updateTeachSubject, removeTeachSubject },
) {
    const selected = [...new Set((selectedSubjectIds || []).map((id) => String(id).trim()).filter(Boolean))];
    if (selected.length < HOMEROOM_MIN_SUBJECTS) {
        return { success: false, message: HOMEROOM_ASSIGN_SUBJECTS_MSG };
    }

    const current = new Set(getTeacherSubjectIdsInClass(teacher, classId));
    const next = new Set(selected);

    for (const subjectId of next) {
        if (current.has(subjectId)) continue;
        const result = await dispatch(updateTeachSubject(teacherId, subjectId));
        if (!result?.success) {
            return {
                success: false,
                message: result?.message || "Could not assign a subject (it may belong to another teacher).",
            };
        }
    }

    for (const subjectId of current) {
        if (next.has(subjectId)) continue;
        const result = await dispatch(removeTeachSubject(teacherId, subjectId));
        if (!result?.success) {
            return { success: false, message: result?.message || "Could not update subject assignments." };
        }
    }

    return { success: true, subjectCount: selected.length };
}
